import { useRequest } from "../../../app/hooks/useRequest";
import { getProgramTypeDeliverablesRequest } from "../ProgramTypeDeliverableRequests";

export const useGetProgramTypeDeliverables = () =>
  useRequest(getProgramTypeDeliverablesRequest);
